import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  cardActions: {
  },
  button: {
    minWidth: '125px',
  },
  buttonCancel: {
    minWidth: '125px',
  },
  alias: {
    marginTop: theme.spacing(4),
  },
}));
